<template>
<div class="chapter">
<div class="inner_page">
<table class="chapter-title-corner-decorations" width="100%"><tbody><tr><td class="chapter-title-corner-decoration-left-column"><div class="chapter-title-corner-decoration-left-column"><img alt="image" class="chapter-title-corner-decoration-left" src="d2d_images/chapter_title_corner_decoration_left.png"/></div></td><td class="chapter-title-corner-decoration-middle-column"> </td><td class="chapter-title-corner-decoration-right-column"><div class="chapter-title-corner-decoration-right-column"><img alt="image" class="chapter-title-corner-decoration-right" src="d2d_images/chapter_title_corner_decoration_right.png"/></div></td></tr></tbody></table><div class="chapter-title"><div class="chapter-title-decoration-above"><div class="chapter-title-decoration-above-inner"><img alt="image" class="chapter-title-decoration-above" src="d2d_images/chapter_title_above.png"/></div></div><h1 class="chapter-title"><a id="__RefHeading___Toc525464173">Série Banqueiro Bilionário</a></h1><a id="__RefHeading___Toc525464173">
<div class="chapter-title-decoration-below"><div class="chapter-title-decoration-below-inner"><img alt="image" class="chapter-title-decoration-below" src="d2d_images/chapter_title_below.png"/></div></div></a></div><p style="text-align: center; text-indent: 0"><a id="__RefHeading___Toc525464173"><img alt="image" class="section-break-symbol" height="275" src="d2d_images/image000.jpg" width="367"/></a></p><a id="__RefHeading___Toc525464173">
<p style="text-align: center; text-indent: 0">Livro 1 – Confiando Nele</p>
<p style="text-align: center; text-indent: 0">Livro 2 – O Preço da Paixão</p>
<p style="text-align: center; text-indent: 0">Livro 3 – Investindo no Amor</p>
<p style="text-align: center; text-indent: 0">Livro 4 – Conhecendo Seu Valor</p>
<p style="text-align: center; text-indent: 0">Livro 5 – Treasured Forever</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c004.vue?4fe0637a